import React from 'react'

import { abbreviateNumber } from '@lib/utils'
import { AdminBadgeIcon } from '@components/icons/AdminBadgeIcon'
import { FacebookIcon } from '@components/icons/FacebookIcon'
import { TwitterIcon } from '@components/icons/TwitterIcon'
import { ProfileSectionProps } from './interface'

export default function ProfileSection({
  displayName,
  userName,
  facebookLink,
  twitterLink,
  totalFollowing,
  totalFollower,
  isAdmin,
  email,
}: ProfileSectionProps) {
  return (
    <div>
      <div data-test='display-name' className='flex items-center space-x-[4px]'>
        <div className='text-secondary dark:text-dark-10 font-bold max-w-[450px] line-clamp-1 break-all leading-[1.8]'>
          {displayName}
        </div>
        {(isAdmin || email === 'admin@mareads.com') && (
          <AdminBadgeIcon className='w-[21.5px] h-[21px]' />
        )}
      </div>
      <div className='text-secondary-1 font-light text-sm'>@{userName}</div>
      <div className='flex flex-1 space-x-[10px] text-secondary-1 font-light text-sm mt-[5px]'>
        <div>
          <span className='font-bold text-secondary dark:text-dark-10'>
            {abbreviateNumber(totalFollowing)}
          </span>{' '}
          กำลังติดตาม
        </div>
        <div>
          <span className='font-bold text-secondary dark:text-dark-10'>
            {abbreviateNumber(totalFollower)}
          </span>{' '}
          ผู้ติดตาม
        </div>
      </div>
      <div className='flex mt-[5px] space-x-[10px]'>
        {facebookLink && (
          <a
            href={facebookLink}
            className='cursor-pointer'
            target='_blank'
            rel='noreferrer'
          >
            <FacebookIcon className='w-[20px] h-[20px]' />
          </a>
        )}
        {twitterLink && (
          <a
            href={twitterLink}
            className='cursor-pointer'
            target='_blank'
            rel='noreferrer'
          >
            <TwitterIcon className='w-[20px] h-[20px]' />
          </a>
        )}
      </div>
    </div>
  )
}
